export default "__VITE_PUBLIC_ASSET__87ef26ba__"